import { PromoType } from "./../appData/productData"
import { Product, ProductPromoPricing } from "../appData/productData"
import ProductDiscountHandler from "../models/productDiscountHandler"

type NativeEvent =
  | "loaded"
  | "analyitcs"
  | "styleConfig"
  | "close"
  | "terms"
  | "privacy"
  | "already_purchased"
  | "subscribe"
  | "subscribeWithProduct"
  | "subscribeWithDiscount"
  | "importPhotos"
  | "skip"

function postNativeEvent(event: NativeEvent, params: any = {}) {
  console.log(`Generated Native event ${event} ${JSON.stringify(params)}`)

  let message: any = { event }
  if (params != null) {
    message["params"] = params
  }

  const webkit = (window as any).webkit

  if (webkit == null) {
    return
  }

  webkit.messageHandlers.handler.postMessage(JSON.stringify(message))
}

function logMixpanelEvent(event: string, params: any = {}) {
  const eventParams = { name: event, params }

  postNativeEvent("analyitcs", eventParams)
}

function subscribe(product: Product, endFlow: boolean = true) {
  postNativeEvent("subscribeWithProduct", {
    productId: product.productId,
    endFlow,
  })
}

function subscribeWithId(id: string) {
  postNativeEvent("subscribeWithProduct", { productId: id })
}

function subscribeWithDiscount(product: Product) {
  const handler = new ProductDiscountHandler(product)

  if (!handler.hasPromoPriceDiscount) {
    return
  }

  subscribeWithPromo(product, handler.promoDiscount)
}

function subscribeWithPromoFreeTrial(product: Product) {
  const handler = new ProductDiscountHandler(product)

  if (!handler.hasFreeTrialDiscount) {
    return
  }

  subscribeWithPromo(product, handler.freeTrialDiscount)
}

function subscribeWithPromo(
  product: Product,
  discount: ProductPromoPricing | undefined,
) {
  if (discount == undefined) {
    return
  }

  postNativeEvent("subscribeWithDiscount", {
    productId: product.productId,
    discountId: discount.identifier,
  })
}

export default {
  postNativeEvent,
  logMixpanelEvent,
  subscribe,
  subscribeWithId,
  subscribeWithDiscount,
  subscribeWithPromoFreeTrial,
}
